export const netsuiteSublists = {
  price1: 'US Dollar',
  price2: 'British Pound',
  price3: 'Canadian Dollar',
  price4: 'Euro',
  price5: 'Australian Dollar',
  price6: 'Danish Krone',
  price7: 'Hong Kong Dollar',
  price8: 'Indian Rupee',
  price9: 'Swedish Krona',
  price: 'Price',
  itemvendor: 'Vendor',
  hierarchyversions: 'Hierarchy Versions',
  billofmaterials: 'Bill of Materials',
  translations: 'Translations',
  quantitypricinglevel: 'Quantity Pricing Level',
  presentationitem: 'Presentation Item',
  member: 'Component',
  members: 'Components',
  project: 'Project',
  projects: 'Projects',
  item: 'Item',
  package: 'Package',
  binnumber: 'Bin Number',
  addressbook: 'Address',
  promotions: 'Promotions',
  paymentevent: 'Payment Event',
  links: 'Links',
  billingschedule: 'Billing Schedule',
  matrix: 'Matrix',
  relitems: 'Related Items',
  correlateditems: 'Correlated Items',
  sitecategory: 'Web Site Categories',
  locations: 'Locations',
  partners: 'Partners',
  salesteam: 'Sales Team',
  currency: 'Currencies',
  subscriptions: 'Subscriptions'
};
